import ValueOf from 'types/valueOf';

export interface Object {
  entriesTS<K extends string | number | symbol, V>(object: Record<K, V>): [K, V][];
  fromEntriesTS<K extends string | number | symbol, V>(entries: readonly (readonly [K, V])[]): Record<K, V>;
  keysTS<K extends string | number | symbol>(object: Record<K, any>): K[];
}

Object.defineProperty(Object.prototype, 'entriesTS', {
  enumerable: false,
  value: function <K extends string | number | symbol, V>(object: Record<K, V>) {
    return Object.entries(object) as [keyof typeof object, ValueOf<typeof object>][];
  },
});

Object.defineProperty(Object.prototype, 'fromEntriesTS', {
  enumerable: false,
  value: function <K extends string | number | symbol, V>(
    entriesOrMap: readonly (readonly [K, V])[] | { [P in K]: readonly [P, V] }
  ) {
    const entries = Array.isArray(entriesOrMap) ? entriesOrMap : Object.values(entriesOrMap);
    return Object.fromEntries(entries);
  },
});

Object.defineProperty(Object.prototype, 'keysTS', {
  enumerable: false,
  value: function <K extends string | number | symbol>(object: Record<K, any>) {
    return Object.keys(object) as K[];
  },
});
